export interface Bonus {
  title: string
  description: string
  price: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Planificateur — Programmation Annuelle',
    description: 'Vos six niveaux répartis sur une année complète de cours.',
    price: '19 €',
    image:
      'https://cdn.magicpatterns.com/uploads/mKMCmYRf1cJ2GZeeCNMkMd/Captura_de_pantalla_2026-09-09_a_la(s)_10.28.59_p._m..png',
  },
  {
    title: 'Fiches Anatomie & Contre-indications',
    description: 'Contre-indications et modifications par zone du corps.',
    price: '19 €',
    image:
      'https://cdn.magicpatterns.com/uploads/qtn9eJc7N4wCtbtWTZmST1/Captura_de_pantalla_2026-09-09_a_la(s)_10.29.09_p._m..png',
  },
  {
    title: 'Guide des Publics Spécifiques',
    description: 'Grossesse, rééducation et troisième âge : adaptations prêtes à appliquer.',
    price: '19 €',
    image:
      'https://cdn.magicpatterns.com/uploads/58q54fsE7J9qTyUqShxqbA/Captura_de_pantalla_2026-09-09_a_la(s)_10.29.19_p._m..png',
  },
  {
    title: 'Checklist Sécurité & Entretien du Reformer',
    description: 'Les contrôles à faire avant, pendant et après le cours.',
    price: '17 €',
    image:
      'https://cdn.magicpatterns.com/uploads/7D2sGHwKFB7gwDLTy4YP5r/Captura_de_pantalla_2026-09-09_a_la(s)_10.29.28_p._m..png',
  },
  {
    title: 'Kit de Communication Client',
    description: 'Modèles de messages prêts à envoyer pour fidéliser votre clientèle.',
    price: '17 €',
    image:
      'https://cdn.magicpatterns.com/uploads/9po8BNZgPTiWoDLwPuYiJx/Captura_de_pantalla_2026-09-09_a_la(s)_10.29.37_p._m..png',
  },
]
